import { h, Component, cloneElement } from 'preact';
import { DeviceVariance } from '@cube/blocks';
import StockPriceBar from '../stock-price-bar';
import Nav from '../stock-details-nav';
import { getStockPrice } from '@os/cloudquote';
import { FinanceSpinner } from '../glyphs';
import config from '../../defaults';
import connect from '@cube/store-connect';

export class StockDetailsPage extends Component {

	// Get the stock type for a symbol, e.g. "stock" or "index"
	getStockType(symbol) {
		getStockPrice(symbol).then(({ rows }) => {
			if (rows && rows[0]) {
				this.setState({
					done: true,
					securityTypeCode: rows[0].SecurityTypeCode,
					uniqueSymbol: rows[0].UniqueSymbol
				});
			}
			else {
				this.setState({ done: true, notFound: true });
			}
		});
	}

	componentWillMount() {
		this.getStockType(this.props.symbol);
	}

	componentWillReceiveProps({ symbol }) {
		if (this.props.symbol !== symbol) {
			this.getStockType(symbol);
		}
	}

	render({ children, showCurrencyIndicator, locale, class: className, ...props }, { done, notFound, securityTypeCode = 'STOCK', uniqueSymbol, hasCompanyData=false, companyProfileData }) {
		return (
			<div class={className}>
				{
					!done && <FinanceSpinner showError />
				}
				{
					done && notFound && <StockPriceBar invalidSymbol {...props} />
				}
				{
					done && !notFound &&
						<div>
							<StockPriceBar {...props} />
							<DeviceVariance
								adaptive
								phone={
									<Nav
										menus={config.tertiaryNavigation.phone}
										type={securityTypeCode}
										uniqueSymbol={uniqueSymbol}
										showCurrencyIndicator={showCurrencyIndicator}
										locale={locale}
										showProfileInfo={hasCompanyData}
										{...props}
									/>}
								other={
									<Nav
										menus={config.tertiaryNavigation.desktop}
										type={securityTypeCode}
										uniqueSymbol={uniqueSymbol}
										showCurrencyIndicator={showCurrencyIndicator}
										locale={locale}
										device={'other'}
										showProfileInfo={hasCompanyData}
										{...props}
									/>}
							/>
							{ children.map(child => cloneElement(child, { showProfileInfo: hasCompanyData })) }
						</div>
				}
			</div>
		);
	}
}

let ConnectedStockDetailsPage = connect(({ locale }) => ({ locale }))(StockDetailsPage);

export default ConnectedStockDetailsPage;



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-details-page/index.js